export const terms = {
  "header": {
    "badge": "Informações legais",
    "title": "Termos de Uso"
  },
  "content": {
    "intro": "Bem-vindo à DONKEY TRAVEL. Estas condições de utilização regem o acesso e utilização da nossa plataforma de troca de habitação. Ao utilizar nossos serviços, você aceita estes termos na íntegra.",
    "eligibility": {
      "title": "1. Elegibilidade e Registro",
      "text": "O acesso ao clube DONKEY TRAVEL é estritamente reservado aos anfitriões com anúncio ativo em plataformas reconhecidas (como Airbnb) com uma classificação global mínima de 4,5 em 5. Qualquer falsificação destes critérios resultará na eliminação imediata da conta sem reembolso da subscrição."
    },
    "subscription": {
      "title": "2. Assinatura e Pagamentos",
      "text": "A plena utilização da plataforma requer a adesão a um dos nossos pacotes (Mensal, Anual ou Club+). Os pagamentos são seguros e processados ​​por fornecedores terceirizados. A assinatura é tacitamente renovável, a menos que seja cancelada pelo usuário."
    },
    "exchanges": {
      "title": "3. Como funcionam as trocas",
      "text": "As trocas dentro do clube são baseadas na confiança e no respeito mútuo. Os acordos de troca são feitos diretamente entre os membros através de nossas mensagens internas. Um contrato de troca moral e, quando aplicável, legal é celebrado entre as duas partes."
    },
    "responsibilities": {
      "title": "4. Compromissos e Responsabilidades",
      "text": "Cada membro compromete-se a apresentar o seu alojamento de forma transparente, com fotos recentes e descrições precisas. O membro anfitrião garante a higiene impecável do local. O membro visitante compromete-se a respeitar escrupulosamente o alojamento e o seu regulamento interno. A DONKEY TRAVEL atua como facilitadora e não é parte nos contratos de troca entre os membros. Não assumimos qualquer responsabilidade por danos, litígios ou cancelamentos de última hora, embora possamos intervir na mediação."
    },
    "termination": {
      "title": "5. Suspensão e Rescisão",
      "text": "A DONKEY TRAVEL reserva-se o direito de suspender ou banir qualquer membro que não respeite as regras de boa conduta da comunidade, acumule mau feedback, ou viole estas condições, unilateralmente."
    },
    "contact": {
      "title": "6. Lei aplicável e disputas",
      "text": "Estas condições são regidas pela lei francesa. Em caso de desacordo, as partes comprometem-se a procurar uma solução amigável antes de qualquer acção judicial perante os tribunais competentes. Para qualquer dúvida, entre em contato conosco em legal@donkey.travel."
    }
  }
};
